module.exports = __webpack_public_path__ + "img/kyivstar_logo.67095022.png";